document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.heritage__video');

  videos.forEach((video) => {
    let userStarted = false;

    // Detect when user manually starts the video
    video.addEventListener('play', () => {
      userStarted = true;
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!userStarted) return;

          if (entry.isIntersecting) {
            // Resume from previous position
            video.play().catch(() => {});
          } else {
            // Pause and keep currentTime
            video.pause();
          }
        });
      },
      {
        threshold: 0.4 // 40% visible
      }
    );

    observer.observe(video);
  });
});